import { ReactNode } from 'react';
export default function DialogActions({children}: {children?:ReactNode;[key:string]:any}) {return <div className="modal-footer">{children}</div>;}
